<app-nav-bar></app-nav-bar>
<app-login-modal></app-login-modal>
<app-alert></app-alert>
<router-outlet></router-outlet>